<template>
  <div>
    <div class="flex flex-wrap-reverse items-center">
      <!-- ADD NEW -->
      <div class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary"
        @click="$router.push({name: 'quote-new'}).catch (err => {})">
        <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
        <span class="ml-2 text-base text-primary">Novo</span>
      </div>
    </div>
    <vue-good-table
      style="width: 100%;"
      styleClass="vgt-table condensed"
      :rows="getQuotes"
      :columns="columns"
      :pagination-options="paginationOptions"
      :search-options="{enabled: true, placeholder: 'Procurar'}">
      <div slot="emptystate" class="text-center">
        Nenhum resultado encontrado
      </div>

      <template slot="column-filter" slot-scope="{ column, updateFilters }">
        <v-select
          appendToBody
          v-if="column.filterOptions && column.filterOptions.enabled"
          :options="column.filterOptions.items"
          :placeholder="column.filterOptions.placeholder || 'Selecione'"
          @input="(valuesArray) => updateFilters(column, valuesArray)">
          <template v-slot:no-options="{ search, searching }">
            <template v-if="searching">
              Nenhuma resultado encontrado para <em>{{ search }}</em>.
            </template>
            <em style="opacity: 0.5;" v-else>Nenhum resultado encontrado</em>
          </template>
        </v-select>
      </template>

      <template slot="table-row" slot-scope="order">
        <span class="font-medium" v-if="order.column.field == 'orcamentos.jsonProdutos'">
          <vs-dropdown class="cursor-pointer" vs-trigger-click>
            <a class="flex items-center" style="font-weight: 500; font-size: 1rem" href="#">
              {{ productsLength(order.row.orcamentos.jsonProdutos) }} itens
              <i class="material-icons"> expand_more </i>
            </a>
            <vs-dropdown-menu>
              <vs-dropdown-item :divider="index != 0" v-for="(product, index) in parseProducts(order.row.orcamentos.jsonProdutos)" v-bind:key="product.codigo">
                Código: {{product.codigo}}
                <br>
                Quantidade: {{product.quantidade}}
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </span>
        <span class="font-medium" v-else-if="order.column.field == 'ações'">
          <div>
            <feather-icon
              icon="EditIcon"
              svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
              @click="editQuote(order.row.orcamentos.idOrcamento)" />
            <feather-icon
              icon="FileTextIcon"
              svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
              @click="generateQuote(order.row.orcamentos.idOrcamento)" />
            <feather-icon
              icon="Trash2Icon"
              svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
              @click="deleteQuote(order.row.orcamentos.idOrcamento)" />
          </div>
        </span>
        <span class="font-medium" v-else>
          {{order.formattedRow[order.column.field]}}
        </span>
      </template>
    </vue-good-table>
    <QuotePdf ref="quotePdf"></QuotePdf>
  </div>
</template>
<script>
import helpers from "@/helpers";
import QuotePdf from './QuotePdf.vue'
import { baseApiUrl } from "@/global"
import axios from "axios"

export default {
  components: {
    QuotePdf,
  },
  data() {
    return {
      quotes: [],
      helpers: null,
      columns: [],
      paginationOptions: {
        enabled: true,
        nextLabel: 'Próxima',
        prevLabel: 'Anterior',
        rowsPerPageLabel: 'Resultados por página',
        ofLabel: 'de',
        pageLabel: 'Página',
        allLabel: 'Todos',
        mode: 'pages',
        perPage: 15
      }
    };
  },
  computed: {
    getQuotes() {
      return this.quotes
    },
  },
  methods: {
    productsLength(products) {
      products = JSON.parse(products)
      return products.length
    },
    parseProducts(products) {
      return JSON.parse(products)
    },
    getAllLabelFilters() {
      let filters = {}
      filters.fantasia = this.quotes.map(item => item.clientes.fantasia.trim())

      for (let filter of Object.keys(filters)) {
        let index = this.columns.findIndex((item) => {
          return item.field.includes(filter)
        });
        this.setDropdownFilter(index, filters[filter])
      }
    },
    setDropdownFilter(index, label) {
      label.sort((a, b) => a.localeCompare(b))
      label = [...new Set(label)]
      this.$set(this.columns[index], 'filterOptions', {
        enabled: true,
        items: label,
      });
    },
    sortJsonProdutos(num, numAnterior) {
      num = this.productsLength(num)
      numAnterior = this.productsLength(numAnterior)
      return (num < numAnterior ? -1 : (num > numAnterior ? 1 : 0));
    },
    async loadQuotes() {
      try {
        this.$vs.loading();
        const response = await axios.post(`${baseApiUrl}/quote/getAllQuotes`);
        this.quotes = response.data
      } catch (error) {
        this.$vs.notify({
          title: "Erro",
          text: "Não foi possivel carregar " + error,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger"
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    mountTable() {
      this.columns = [{
          label: 'ID',
          field: 'orcamentos.idOrcamento',
        },
        {
          label: 'Cliente',
          field: 'clientes.fantasia',
        },
        {
          label: 'Criado Por',
          field: 'usuarios.nome',
          filterOptions: {
            enabled: true,
            items: ['RAPHAEL', 'GILMAR'],
          }
        },
        {
          label: 'Data de Criação',
          field: 'orcamentos.criadoEm',
          formatFn: this.helpers.dateHelper.formatDateTimeToPTBR
        },
        {
          label: 'Produtos',
          field: 'orcamentos.jsonProdutos',
          sortFn: this.sortJsonProdutos
        },
        {
          label: 'Transportadora',
          field: 'transportadoras.nomeCurto',
        },
        {
          label: 'Ações',
          field: 'ações',
          sortable: false
        },
      ]
    },
    editQuote(id) {
      this.$router.push(`/orcamentos/editar/${id}`)
    },
    generateQuote(id) {
      // this.$router.push(`/orcamentos/gerar/${id}`)
      this.$refs.quotePdf.generate(id)
    },
    deleteQuote(id) {
      console.log('deletar: ', id)
    },
  },
  async created() {
    this.helpers = helpers
    await this.loadQuotes()
    this.mountTable()
    this.getAllLabelFilters()
  },
};

</script>
<style lang="scss">
table.vgt-table {
  font-size: 1rem;
}

</style>
